<template>
  <div class="no-layout"></div>
</template>

<script>
export default {
  mounted() {
    const layoutRedirectURL = window.sessionStorage.getItem(
      "layoutRedirectURL"
    );

    if (layoutRedirectURL) {
      this.$router.replace({ path: layoutRedirectURL });
    }
  },
};
</script>
